import { fetchUser } from '@/services/auth'

export const AUTH_REQUEST_TOKEN = 'AUTH_REQUEST_TOKEN'
export const AUTH_REFRESH_TOKEN = 'AUTH_REFRESH_TOKEN'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'

export const AUTH_STORE_USER = 'AUTH_STORE_USER'
export const AUTH_CLEAR_USER = 'AUTH_CLEAR_USER'

export default {
  namespaced: true,

  state: {
    user: null,
    token: '',
    expires_in: null,
    type: null,
    status: false
  },

  getters: {
    isAuthenticated: state => !!state.token,

    user: state => state.user || {},

    token: state => state.token || ''
  },

  actions: {
    refreshTokenAndUser ({ dispatch }, [auth]) {
      return new Promise((resolve, reject) => {
        dispatch('storeToken', [auth])
        dispatch('fetchUser').then(() => {
          resolve()
        })
      })
    },

    storeToken ({ commit, dispatch }, [auth]) {
      commit(AUTH_SUCCESS, [auth])
      dispatch('fetchUser')
    },

    revokeToken ({ commit }) {
      commit(AUTH_LOGOUT)
    },

    fetchUser ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        fetchUser().then((res) => {
          commit(AUTH_STORE_USER, [res.data])
          resolve()
        }).catch((e) => {
          commit(AUTH_LOGOUT)

          if (e.response) {
            dispatch('errors/pushGlobalError', [e.response.data], { root: true })
          }

          reject(e)
        })
      })
    }
  },

  mutations: {
    [AUTH_REQUEST_TOKEN] (state) {
      state.status = state.status
    },

    [AUTH_SUCCESS] (state, [auth]) {
      const data = JSON.parse(auth.token())

      state.token = data.access_token
      state.expires_in = data.expires_in
      state.type = data.token_type

      state.status = true
    },

    [AUTH_LOGOUT] (state) {
      localStorage.removeItem('default_auth_token')

      state.user = null
      state.token = ''
      state.expires_in = null
      state.type = null
      state.status = false
    },

    [AUTH_STORE_USER] (state, [user]) {
      state.user = user
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/auth.js